export default __webpack_public_path__ + "static/media/header_f.3c2fd82e.png";